module.exports = __webpack_public_path__ + "static/media/SeattleChildrens.05b3a453.png";